import {
        FETCH_RANCKING_TOP,
        FETCH_RANCKING_TURMAS,
        FETCH_RANCKING_TURMAS_TOP,
        FETCH_RANCKING_BADGE,
        FETCH_ACTION_BADGE,
       } from '../actions/talentosAction';

const INITIAL_STATE = { 
                        allRanckingTop     : [],
                        allRankingTurma    : [],
                        allRankingTurmaTop : [],
                        allBadge           : [],
                        allBadgePrincipal  : {},
                      };

export default function(state = INITIAL_STATE,action){

    switch (action.type) {

        case FETCH_RANCKING_TOP:            
             return { ...state, allRanckingTop:(action.payload.data?action.payload.data:[]) }

        case FETCH_RANCKING_TURMAS:            
             return { ...state, allRankingTurma:(action.payload.data?action.payload.data:[]) }

        case FETCH_RANCKING_TURMAS_TOP:            
             return { ...state, allRankingTurmaTop:(action.payload.data?action.payload.data:[]) }

        case FETCH_RANCKING_BADGE:            
             return { ...state, allBadge:action.payload.data, allBadgePrincipal:action.payload.data.badge_principal }

        case FETCH_ACTION_BADGE:            
             return { ...state, allBadgePrincipal:action.payload.data }

        default:
           return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/reducer_talentos.js